/* tslint:disable */
import { Injectable } from '@angular/core';
import { AppUser } from '../../models/AppUser';
import { Article } from '../../models/Article';
import { Category } from '../../models/Category';
import { CostGuide } from '../../models/CostGuide';
import { Page } from '../../models/Page';
import { FixrAPI } from '../../models/FixrAPI';
import { ProfessionAnnualWagesIndex } from '../../models/ProfessionAnnualWagesIndex';
import { CostsOfLiving } from '../../models/CostsOfLiving';
import { ProfessionCategory } from '../../models/ProfessionCategory';
import { Taxes } from '../../models/Taxes';
import { ZipcodeModificationFactor } from '../../models/ZipcodeModificationFactor';
import { Job } from '../../models/Job';
import { TaxSim } from '../../models/TaxSim';
import { City } from '../../models/City';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    AppUser: AppUser,
    Article: Article,
    Category: Category,
    CostGuide: CostGuide,
    Page: Page,
    FixrAPI: FixrAPI,
    ProfessionAnnualWagesIndex: ProfessionAnnualWagesIndex,
    CostsOfLiving: CostsOfLiving,
    ProfessionCategory: ProfessionCategory,
    Taxes: Taxes,
    ZipcodeModificationFactor: ZipcodeModificationFactor,
    Job: Job,
    TaxSim: TaxSim,
    City: City,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/services/custom/SDKModels.ts